import React from 'react';
import { Skeleton } from '@fourthwall/components';
export const BadgesSkeleton = () => (React.createElement(Skeleton, { gap: 40 },
    React.createElement(Skeleton, { gap: 16 },
        React.createElement(Skeleton.Shape, { width: "100%", height: 40 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 90 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 90 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 90 })),
    React.createElement(Skeleton, { gap: 16 },
        React.createElement(Skeleton.Shape, { width: "100%", height: 40 }),
        React.createElement(Skeleton.Shape, { width: "100%", height: 140 }))));
